import BaseChart from './BaseChart';

/**
 * Funnel chart implementation using VChart
 */
class FunnelChart extends BaseChart {
  /**
   * Get chart specification for funnel chart
   * @returns {Object} Chart specification
   */
  getChartSpecification() {
    const commonConfig = this.getCommonConfig();
    const data = this.prepareData();

    // Funnel specific fields — auto-detect from data when not provided
    const nameField = this._resolveNameField();
    const valueField = this._resolveValueField();
    
    return {
      type: 'funnel',
      data,
      categoryField: nameField,
      valueField,
      
      // Funnel specific styling
      funnel: {
        style: {
          stroke: '#fff',
          lineWidth: 1,
          ...this.options.funnelStyle
        },
        state: {
          hover: {
            stroke: '#fff',
            lineWidth: 2,
            offset: 5
          },
          ...this.options.funnelState
        }
      },
      
      // Label configuration
      label: {
        visible: this.options.showLabels !== false,
        position: this.options.labelPosition || 'right',
        style: {
          fontSize: 12,
          fontWeight: 'normal',
          ...this.options.labelStyle
        },
        formatter: this.options.labelFormatter || ((datum) => {
          return `${datum[nameField]}: ${datum[valueField]}`;
        })
      },
      
      // Animation configuration
      animationAppear: {
        duration: 800,
        easing: 'cubicOut',
        ...this.options.animationAppear
      },
      
      // Common configuration from BaseChart
      ...commonConfig
    };
  }
  
  /**
   * Prepare data for VChart format with percentage calculation
   * @returns {Array} Formatted data for VChart
   */
  prepareData() {
    const valueField = this._resolveValueField();

    // Sort data by value if requested
    let formattedData = [...this.data];
    if (this.options.sort) {
      formattedData.sort((a, b) => b[valueField] - a[valueField]);
    }
    
    // Calculate percentage for each item
    if (formattedData.length > 0) {
      const maxValue = formattedData[0][valueField];
      
      formattedData = formattedData.map(item => ({
        ...item,
        _percentage: item[valueField] / maxValue * 100
      }));
    }
    
    return [
      {
        id: 'funnelData',
        values: formattedData
      }
    ];
  }
}

export default FunnelChart; 